import { SET_PROTECTED_DEVICE } from './';

export default function setProtectedDevice() {
  return dispatch => {
    dispatch({ type: SET_PROTECTED_DEVICE });
  };
}
